import http from "../../axios-config/g-http-metodos";

function GetImpostosByRepresentante(representanteId) {
    const { res, erro, requisicao } = http.getArray(`GerenciamentoImpostos/GetImpostosByRepresentante/${representanteId}`);
    return { res, erro, requisicao };
}

function AtualizaImpostosByRepresentanteId(representanteId, IR, ISS){
    const { res, erro, requisicao } = http.post(`GerenciamentoImpostos/AtualizaImpostosByRepresentanteId/${representanteId}/${IR}/${ISS}`);
    return { res, erro, requisicao };
}

const GerenciamentoImpostosController = {
    GetImpostosByRepresentante,
    AtualizaImpostosByRepresentanteId
}

export default GerenciamentoImpostosController
